import a from "./arrayLikeToArray.js";
function t(r) {
  if (Array.isArray(r))
    return a(r);
}
export {
  t as default
};
//# sourceMappingURL=arrayWithoutHoles.js.map
